import { Injectable } from '@angular/core';
import { CategoryApiService } from '../services/category-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CategoryStoreService } from './category.store.service';
import { Observable } from 'rxjs';
import * as fromAction from './category.action';
import { Action } from '@ngrx/store';
import { map, switchMap } from 'rxjs/operators';
import { categoryFeatureKey } from './category.state';
import { EffectHelperService } from '@modules/core/services/effect-helper.service';
import { PageList } from '@core/models/page-list';
import { Category } from '@modules/category/models/category';

@Injectable()
export class CategoryStoreEffects {

  fetchCategoriesEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.FetchCategories),
    switchMap(({categoryPagination, categoryFilter}) =>
      this.categoryApiService
        .fetchCategories(categoryPagination, categoryFilter)
        .pipe(
          map(({items: categories, total}: PageList<Category>) => {
            this.categoryStoreService.addCategoryTotalCount(total);
            return this.effectHelperService.handleSuccess(fromAction.AddCategories({ categories }))
          }),
          this.effectHelperService.handleError(fromAction.AddError, true, categoryFeatureKey)
        )
    )
  ));


  getCategoryByIdEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(fromAction.GetCategory),
    switchMap((payload) =>
      this.categoryApiService
        .getById(payload.id)
        .pipe(
          map((category) => this.effectHelperService.handleSuccess(fromAction.AddCategory({ category: category }))),
          this.effectHelperService.handleError(fromAction.AddError, true, categoryFeatureKey)
        )
    )
  )
  );

  constructor(
    private categoryApiService: CategoryApiService,
    private actions$: Actions,
    private categoryStoreService: CategoryStoreService,
    private effectHelperService: EffectHelperService
  ) { }
}
